// import React from 'react'
import img from "../../Assets/Sectors/AboutSectorsimgs.png";
// const AboutSectors = () => {
//     return (
//         <React.Fragment>
//                     <div className="flex flex-col lg:flex-row items-center md:mx-16 mx-6 mt-10 space-y-3 md:space-x-14">
//                         <div className="lg:w-1/2" data-aos="fade-right">
//                             <img
//                                 src={img}
//                                 alt="Construction of a large bridge with multiple cranes and scaffolding"
//                                 className="rounded-lg shadow-lg"
//                             />
//                         </div>
//                         <div className="lg:w-1/2"  data-aos="fade-up-left">
//                             <h2 className="text-3xl md:text-5xl font-semibold  mb-4" data-aos="fade-up">About</h2>
//                             <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
//                                 Bridges, Fly overs, Road over bridges, Interchanges, ROB/RUB etc are integral part of road and railway development sectors and also in urban area. The technology advancement in bridge sector has witnessed construction of iconic structures with long span, and aesthetics. This sector also requires assessment of existing bridges and providing solution for rehabilitation or strengthening. Our Team of experts have the competency of planning and design of all types of Bridges, Fly overs, road over bridges, Interchanges, ROB/RUB besides taking up proof consultancy of design, supervision Consultancy for bridge projects.
//                             </p>
//                         </div>
//                     </div>
//         </React.Fragment>
//     )
// }

// export default AboutSectors

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import SimpleBanner from "../../Screens/Common/SimpleBanner";
import AboutUs_banner from "../../Assets/About/banaraimg.png";
const AboutSectors = () => {
  const location = useLocation();
  const sector = location.state?.sector; // Get sector data from navigation state
  const [selectedHighway, setSelectedHighway] = useState("National Highway");
  if (!sector) {
    return (
      <>
        <SimpleBanner
          image={AboutUs_banner}
          name="Sectors"
          path="Home / Sectors"
        />
        <div className="flex flex-col lg:flex-row items-center md:mx-16 mx-6 mt-10 space-y-3 md:space-x-14">
          <div className="lg:w-1/2" data-aos="fade-right">
            <img
              src={img}
              alt="Construction of a large bridge with multiple cranes and scaffolding"
              className="rounded-lg shadow-lg"
            />
          </div>
          <div className="lg:w-1/2" data-aos="fade-up-left">
            <h2
              className="text-3xl md:text-5xl font-semibold  mb-4"
              data-aos="fade-up"
            >
              About
            </h2>
            <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
              Bridges, Fly overs, Road over bridges, Interchanges, ROB/RUB etc
              are integral part of road and railway development sectors and also
              in urban area. The technology advancement in bridge sector has
              witnessed construction of iconic structures with long span, and
              aesthetics. This sector also requires assessment of existing
              bridges and providing solution for rehabilitation or
              strengthening. Our Team of experts have the competency of planning
              and design of all types of Bridges, Fly overs, road over bridges,
              Interchanges, ROB/RUB besides taking up proof consultancy of
              design, supervision Consultancy for bridge projects.
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SimpleBanner
        image={AboutUs_banner}
        name={`${sector.name}`}
        path="Home /  Sectors"
      />
      <div className="md:mt-14 mt-7">
        <div className="flex flex-col lg:flex-row  md:mx-16 mx-6 mt-10 space-y-3 lg:space-x-14">
          <div className="lg:w-1/2" data-aos="fade-right">
            <img
              src={sector.image}
              alt={sector.name}
              className="rounded-lg shadow-lg w-full h-auto object-cover"
            />
          </div>
          <div className="lg:w-1/2" data-aos="fade-up-left">
            <h2
              className="lg:text-3xl text-2xl  font-semibold mb-4"
              data-aos="fade-up"
            >
              {/* {sector.name} */}
              About
            </h2>
            <div className="flex flex-col space-y-4">
              {sector.name === "Highways" ? (
                <div>
                  <div className="flex space-x-4 mb-4">
                    {Object.keys(sector.highwayTypes).map((type) => (
                      <button
                        key={type}
                        className={`tracking-wide font-bold py-2 px-4 rounded ${
                          selectedHighway === type
                            ? "bg-[#1522ED] text-white"
                            : "bg-gray-200"
                        }`}
                        onClick={() => setSelectedHighway(type)}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                  <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
                    {sector.highwayTypes[selectedHighway]}
                  </p>
                </div>
              ) : (
                <>
                  <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
                    {sector.about2}
                  </p>
                  <p className="text-gray-600 text-base md:text-md lg:text-xl tracking-wide">
                    {sector.about3}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutSectors;
